import { serviceApi } from '~/api';

const brandsUrl = 'brands';

export const get = () => serviceApi.fetchJSON(brandsUrl);

export const brandsApi = {
  get,
};
